module.exports = __webpack_public_path__ + "img/smile.8270e9d8.svg";